export default __webpack_public_path__ + "static/media/0x521cddc0cba84f14c69c1e99249f781aa73ee0bc.7e066a24.webp";